<asl-google-signin-button type="standard" size="large"></asl-google-signin-button>
